var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.376c11.046 0 20-8.954 20-20 0-11.045-8.954-20-20-20s-20 8.955-20 20c0 11.046 8.954 20 20 20Zm-2.983-7.889V22.383h-3.684v-4.25h3.684v-3.188a5.157 5.157 0 0 1 3.29-5.34c.703-.269 1.456-.38 3.955-.327-.367-.003-.17.013.27.05h.001c.335.029.808.069 1.281.12v3.825h-2.252c-1.785 0-2.125.85-2.125 2.083v2.734h4.25l-.553 4.25h-3.697v10.147h-4.42Z"
  })));
};
export default SvgFacebook;